import React, { useState } from 'react';
import { signIn, isAuthenticated, signOut } from '../supabase';

export function checkAuth() {
  return isAuthenticated();
}

export function clearAuth() {
  signOut();
}

export default function Login({ onAuth, accessDenied }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [shake, setShake] = useState(false);

  const attempt = async () => {
    if (!email || !password) return;
    setLoading(true);
    setError('');
    try {
      await signIn(email, password);
      onAuth();
    } catch (err) {
      setError(err.message || 'Incorrect credentials');
      setShake(true);
      setPassword('');
      setTimeout(() => setShake(false), 600);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className={`login-box ${shake ? 'shake' : ''}`}>
        <div className="login-brand">
          <span className="login-brand-name">TREJHARA</span>
          <span className="login-brand-sub">Operations</span>
        </div>
        <input
          className="login-input"
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => { setEmail(e.target.value); setError(''); }}
          onKeyDown={e => e.key === 'Enter' && attempt()}
          autoFocus
        />
        <input
          className={`login-input ${error ? 'error' : ''}`}
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => { setPassword(e.target.value); setError(''); }}
          onKeyDown={e => e.key === 'Enter' && attempt()}
          style={{ marginTop: 10 }}
        />
        {accessDenied && <p className="login-error">Access denied. You don't have permission to view this dashboard.</p>}
        {error && <p className="login-error">{error}</p>}
        <button
          className="login-btn"
          onClick={attempt}
          disabled={loading}
        >
          {loading ? 'Signing in…' : 'Enter'}
        </button>
      </div>
    </div>
  );
}
